exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-all-occurrences[data-v-241cf20a] {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 2rem;\n}\n.show-plus[data-v-241cf20a]{\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.tables th[data-v-241cf20a],.tables td[data-v-241cf20a]  {\n\tborder: none;\n}\n.tables tr[data-v-241cf20a]:nth-child(even) {\n\tbackground-color: rgba(0, 0, 0, 0.05);\n}\n.tables th[data-v-241cf20a] {\n\tbackground-color: #1c869a;\n\tcolor:white;\n\tpadding: 8px;\n\tborder:groove 1px lightgray\n}\n.no-results[data-v-241cf20a] {\n\tpadding: 8px;\n\ttext-align: center;\n}\n", ""]);

// exports
